
import { head, tail, isEmpty, singleton as singleton_1, ofArray, cons } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { HtmlHelper_createElement } from "../fable_modules/Feliz.3.3.3/Html.fs.js";
import { minHeight_minHScreen, display_block, height_h8, justifyContent_justifyBetween, padding_px8, maxWidth_w7Xl, boxShadow_shadowXs, grid_cols$002D3, maxWidth_w3Xl, margin_mb8, padding_py4, padding_px6, flex_flexRow, margin_mt4, fontSize_textXl, margin_mxAuto, height_h12, width_w12, gap_gap$002D3, margin_mb2, fontWeight_fontBold, fontSize_text2Xl, backgroundImage_bgGradientToR, display_grid, gap_gap$002D6, flex_flexCol, border_border, padding_py8, padding_p6, boxShadow_shadow, textAlign_center, margin_mb4, fontSize_textLg, zIndex_z30, opacity_opacity20, backgroundColor_bgBlack, flexDirection_flexCol, boxShadow_shadowXl, width_w72, padding_p4, justifyContent_justifyEnd, margin_my2, outline_outlineNone, fontSize_textBase, padding_py3, ringOffsetWidth_ringOffset2, ring_ring2, height_h9, width_w9, justifyContent_justifyCenter, display_hidden, width_w36, padding_p2, fontWeight_fontMedium, backgroundColor_bgNeutral50, border_border2, fontWeight_fontSemibold, textColor_white, borderRadius_roundedLg, display_inlineFlex, textAlign_left, width_wFull, margin_my1, fontSize_textSm, padding_px4, padding_py1, zIndex_z50, ring_ring1, boxShadow_shadowLg, width_w48, margin_mt2, position_right0, position_absolute, zIndex_z40, position_inset0, position_fixed$0027, transition_transitionColors, backgroundColor_bgNeutral100, borderRadius_roundedMd, padding_py2, padding_px3, gap_gap$002D2, position_relative, gap_gap$002D4, alignItems_itemsCenter, display_flex, tw } from "../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { map, collect, empty, append, singleton, delay, toList } from "../fable_modules/fable-library-js.5.3.0/Seq.js";
import { padding_py16, minHeight_minHDvh, backgroundColor_bgPrimary50, borderColor_borderPrimary600, gap_gap4, sm, backgroundColor_bgPrimary100, borderRadius_roundedFull, textColor_textPrimary50, gradientColorStops_toSecondary600, gradientColorStops_fromPrimary500, space_spaceY6, gap_gap8, grid_gridCols1fr280px, lg, borderColor_borderNeutral300, backgroundColor_bgPrimary700, space_spaceY3, backgroundColor_bgSurface, textColor_textNeutral900, borderColor_borderNeutral200, ringColor_ringPrimary500, textColor_textPrimary600, md, textColor_textOnPrimary, backgroundColor_bgPrimary600, textColor_textNeutral600, backgroundColor_bgSecondary50, textColor_textSecondary600, borderColor_borderSecondary600, backgroundColor_bgSecondary700, backgroundColor_bgSecondary600, textColor_textNeutral500, borderColor_borderNeutral100, focusVisible, ring_ringBlack5, backgroundColor_bgSurfaceElevated, textColor_textNeutral700, FocusVisible_ring, hover } from "./TailwindExtensions.js";
import { ClientTypes_ThemePreference, ClientTypes_signUpMsg, ClientTypes_Route, ClientTypes_Msg } from "./ClientTypes.js";
import { Fragment, useEffect, useRef, createElement } from "react";
import React from "react";
import { IconWeight, IconSize, IconName, icon as icon_2 } from "./Icons.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.3.0/Option.js";
import { split, printf, toText, join } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { focusPrev, focusNext } from "./MenuKeyboard.js";
import { disposeSafe, equals } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.3.0/FSharp.Core.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { lookupForAuth, navRoute, lookup } from "./Layout/PageMeta.js";
import { defaultOf as defaultOf_1 } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { ListState, render } from "./Challenge/ChallengeList.js";
import { centeredSpinner, emptyStateFull, emptyStateCompact } from "./Layout/Interactions.js";
import { TailwindHelpers_buttonPrimary } from "./Layout/Layout.js";
import { HomePromo_view } from "./FloodReliefPage.js";
import { Clock_system } from "./Clock.js";
import { item } from "../fable_modules/fable-library-js.5.3.0/Array.js";
import { view as view_1 } from "./Pledge/MyPledgesView.js";
import { PromotionModule_floodRelief2026, PromotionModule_isRunning } from "./Promotion.js";
import { paragraphs } from "./BusinessDescription.js";

function withKey(k, props) {
    return cons(["key", k], props);
}

export function AuthComponents_authStatus(model, dispatch, showUserMenu) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D4]))], ["children", toList(delay(() => {
        const matchValue = model.Auth;
        switch (matchValue.tag) {
            case 1:
                return singleton(HtmlHelper_createElement("div", ofArray([["className", position_relative], ["children", toList(delay(() => append(singleton(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, padding_px3, padding_py2, borderRadius_roundedMd, hover(backgroundColor_bgNeutral100), transition_transitionColors, FocusVisible_ring]))], ["aria-label", "user menu"], ["aria-expanded", model.ShowUserMenu ? "true" : "false"], ["onClick", (_arg_2) => {
                    dispatch(new ClientTypes_Msg(11, []));
                }], ["children", [createElement(icon_2, {
                    name: new IconName(26, []),
                    size: new IconSize(1, []),
                    weight: new IconWeight(0, []),
                }), HtmlHelper_createElement("span", ofArray([["className", textColor_textNeutral700], ["children", singleton_1(defaultArg(matchValue.fields[1], "User"))]])), createElement(icon_2, {
                    name: new IconName(39, []),
                    size: new IconSize(0, []),
                    weight: new IconWeight(0, []),
                })]]]))), delay(() => (showUserMenu ? append(singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([position_fixed$0027, position_inset0, zIndex_z40]))], ["aria-hidden", true], ["onClick", (_arg_3) => {
                    dispatch(new ClientTypes_Msg(12, []));
                }]]))), delay(() => singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([position_absolute, position_right0, margin_mt2, width_w48, borderRadius_roundedMd, boxShadow_shadowLg, backgroundColor_bgSurfaceElevated, ring_ring1, ring_ringBlack5, zIndex_z50]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", padding_py1], ["role", join(" ", ["menu"])], ["aria-orientation", "vertical"], ["onKeyDown", (e) => {
                    const matchValue_1 = e.key;
                    switch (matchValue_1) {
                        case "Escape": {
                            e.preventDefault();
                            dispatch(new ClientTypes_Msg(12, []));
                            break;
                        }
                        case "ArrowDown": {
                            e.preventDefault();
                            focusNext(e.currentTarget);
                            break;
                        }
                        case "ArrowUp": {
                            e.preventDefault();
                            focusPrev(e.currentTarget);
                            break;
                        }
                        default:
                            undefined;
                    }
                }], ["children", [HtmlHelper_createElement("a", ofArray([["href", "#"], ["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, padding_px4, padding_py2, fontSize_textSm, textColor_textNeutral700, hover(backgroundColor_bgNeutral100), focusVisible(backgroundColor_bgNeutral100), FocusVisible_ring]))], ["role", join(" ", ["menuitem"])], ["tabIndex", 0], ["autoFocus", true], ["onClick", (e_1) => {
                    e_1.preventDefault();
                    dispatch(new ClientTypes_Msg(12, []));
                    dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(5, [])]));
                }], ["children", [createElement(icon_2, {
                    name: new IconName(27, []),
                    size: new IconSize(1, []),
                    weight: new IconWeight(0, []),
                }), "Profile"]]])), HtmlHelper_createElement("hr", singleton_1(["className", tw(ofArray([margin_my1, borderColor_borderNeutral100]))])), HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, width_wFull, textAlign_left, padding_px4, padding_py2, fontSize_textSm, textColor_textNeutral700, hover(backgroundColor_bgNeutral100), focusVisible(backgroundColor_bgNeutral100), FocusVisible_ring]))], ["role", join(" ", ["menuitem"])], ["tabIndex", 0], ["onClick", (_arg_4) => {
                    dispatch(new ClientTypes_Msg(12, []));
                    dispatch(new ClientTypes_Msg(8, []));
                }], ["children", [createElement(icon_2, {
                    name: new IconName(28, []),
                    size: new IconSize(1, []),
                    weight: new IconWeight(0, []),
                }), "Sign Out"]]]))]]]))]]]))))) : empty())))))]])));
            case 2:
            case 3:
            case 4:
                return singleton(HtmlHelper_createElement("span", ofArray([["className", textColor_textNeutral500], ["children", singleton_1("Loading...")]])));
            default:
                return singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2]))], ["children", [HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, gap_gap$002D2, padding_px4, padding_py2, borderRadius_roundedLg, backgroundColor_bgSecondary600, textColor_white, fontWeight_fontSemibold, hover(backgroundColor_bgSecondary700), FocusVisible_ring, transition_transitionColors]))], ["onClick", (_arg) => {
                    dispatch(new ClientTypes_Msg(1, []));
                }], ["children", [createElement(icon_2, {
                    name: new IconName(24, []),
                    size: new IconSize(1, []),
                    weight: new IconWeight(0, []),
                }), "Sign In"]]])), HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, gap_gap$002D2, padding_px4, padding_py2, borderRadius_roundedLg, border_border2, borderColor_borderSecondary600, textColor_textSecondary600, fontWeight_fontSemibold, hover(backgroundColor_bgSecondary50), FocusVisible_ring, transition_transitionColors]))], ["onClick", (_arg_1) => {
                    dispatch(ClientTypes_signUpMsg(model.CurrentRoute));
                }], ["children", [createElement(icon_2, {
                    name: new IconName(25, []),
                    size: new IconSize(1, []),
                    weight: new IconWeight(0, []),
                }), "Sign Up"]]]))]]])));
        }
    }))]]));
}

const ThemeToggle_sunIcon = createElement(icon_2, {
    name: new IconName(21, []),
    size: new IconSize(1, []),
    weight: new IconWeight(0, []),
});

const ThemeToggle_moonIcon = createElement(icon_2, {
    name: new IconName(22, []),
    size: new IconSize(1, []),
    weight: new IconWeight(0, []),
});

const ThemeToggle_monitorIcon = createElement(icon_2, {
    name: new IconName(23, []),
    size: new IconSize(1, []),
    weight: new IconWeight(0, []),
});

function ThemeToggle_themeOption(label, icon, pref, current, dispatch) {
    return HtmlHelper_createElement("button", toList(delay(() => append(singleton(["className", tw(toList(delay(() => append(singleton(display_flex), delay(() => append(singleton(alignItems_itemsCenter), delay(() => append(singleton(gap_gap$002D2), delay(() => append(singleton(width_wFull), delay(() => append(singleton(padding_px4), delay(() => append(singleton(padding_py2), delay(() => append(singleton(fontSize_textSm), delay(() => append(singleton(textColor_textNeutral700), delay(() => append(singleton(hover(backgroundColor_bgNeutral100)), delay(() => append(equals(pref, current) ? append(singleton(backgroundColor_bgNeutral50), delay(() => singleton(fontWeight_fontMedium))) : empty(), delay(() => append(singleton(focusVisible(backgroundColor_bgNeutral100)), delay(() => singleton(FocusVisible_ring))))))))))))))))))))))))))]), delay(() => append(singleton(["role", join(" ", ["menuitem"])]), delay(() => append(singleton(["tabIndex", 0]), delay(() => append(equals(pref, current) ? append(singleton(["autoFocus", true]), delay(() => (equals(pref, current) ? singleton(["ref", (el) => {
        if (!Operators_IsNull(el)) {
            window.setTimeout(() => {
                el.focus();
            }, 0);
        }
    }]) : empty()))) : empty(), delay(() => append(singleton(["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(13, [pref]));
    }]), delay(() => singleton(["children", [icon, HtmlHelper_createElement("span", singleton_1(["children", singleton_1(label)]))]]))))))))))))));
}

export function ThemeToggle_themeToggle(model, dispatch) {
    return HtmlHelper_createElement("div", ofArray([["className", position_relative], ["children", toList(delay(() => append(singleton(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([padding_p2, borderRadius_roundedMd, hover(backgroundColor_bgNeutral100), transition_transitionColors, textColor_textNeutral600, FocusVisible_ring]))], ["aria-label", "theme"], ["aria-expanded", model.ShowThemeMenu ? "true" : "false"], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(14, []));
    }], ["onKeyDown", (e) => {
        const matchValue = e.key;
        let matchResult;
        switch (matchValue) {
            case "ArrowDown": {
                if (model.ShowThemeMenu) {
                    matchResult = 0;
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            case "Enter": {
                if (model.ShowThemeMenu) {
                    matchResult = 1;
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            case " ": {
                if (model.ShowThemeMenu) {
                    matchResult = 1;
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            default:
                matchResult = 2;
        }
        switch (matchResult) {
            case 0: {
                e.preventDefault();
                break;
            }
            case 1: {
                e.preventDefault();
                dispatch(new ClientTypes_Msg(15, []));
                break;
            }
            case 2: {
                let matchResult_1;
                switch (matchValue) {
                    case "ArrowDown": {
                        if (!model.ShowThemeMenu) {
                            matchResult_1 = 0;
                        }
                        else {
                            matchResult_1 = 2;
                        }
                        break;
                    }
                    case "Escape": {
                        if (model.ShowThemeMenu) {
                            matchResult_1 = 1;
                        }
                        else {
                            matchResult_1 = 2;
                        }
                        break;
                    }
                    default:
                        matchResult_1 = 2;
                }
                switch (matchResult_1) {
                    case 0: {
                        e.preventDefault();
                        dispatch(new ClientTypes_Msg(14, []));
                        break;
                    }
                    case 1: {
                        e.preventDefault();
                        dispatch(new ClientTypes_Msg(15, []));
                        break;
                    }
                    case 2: {
                        break;
                    }
                }
                break;
            }
        }
    }], ["children", toList(delay(() => {
        const matchValue_1 = model.ThemePreference;
        return (matchValue_1.tag === 1) ? singleton(ThemeToggle_moonIcon) : ((matchValue_1.tag === 2) ? singleton(ThemeToggle_monitorIcon) : singleton(ThemeToggle_sunIcon));
    }))]]))), delay(() => (model.ShowThemeMenu ? append(singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([position_fixed$0027, position_inset0, zIndex_z40]))], ["aria-hidden", true], ["onClick", (_arg_1) => {
        dispatch(new ClientTypes_Msg(15, []));
    }]]))), delay(() => singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([position_absolute, position_right0, margin_mt2, width_w36, borderRadius_roundedMd, boxShadow_shadowLg, backgroundColor_bgSurfaceElevated, ring_ring1, ring_ringBlack5, zIndex_z50]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", padding_py1], ["role", join(" ", ["menu"])], ["aria-orientation", "vertical"], ["onKeyDown", (e_1) => {
        const matchValue_2 = e_1.key;
        switch (matchValue_2) {
            case "Escape": {
                e_1.preventDefault();
                dispatch(new ClientTypes_Msg(15, []));
                break;
            }
            case "ArrowDown": {
                e_1.preventDefault();
                focusNext(e_1.currentTarget);
                break;
            }
            case "ArrowUp": {
                e_1.preventDefault();
                focusPrev(e_1.currentTarget);
                break;
            }
            default:
                undefined;
        }
    }], ["children", [ThemeToggle_themeOption("Light", ThemeToggle_sunIcon, new ClientTypes_ThemePreference(0, []), model.ThemePreference, dispatch), ThemeToggle_themeOption("Dark", ThemeToggle_moonIcon, new ClientTypes_ThemePreference(1, []), model.ThemePreference, dispatch), ThemeToggle_themeOption("System", ThemeToggle_monitorIcon, new ClientTypes_ThemePreference(2, []), model.ThemePreference, dispatch)]]]))]]]))))) : empty())))))]]));
}

const MobileBar_pillClasses = tw(ofArray([backgroundColor_bgPrimary600, textColor_textOnPrimary, "rounded-full", fontSize_textSm, fontWeight_fontSemibold, padding_px3, padding_py1]));

/**
 * Renders the green title pill, suppressed/no-chrome cases return Html.none.
 * On SystemTitleDropped routes the pill IS the <h1>; on UserContentKept routes it's a <span>.
 */
export function MobileBar_mobileTitlePill(entry) {
    const matchValue = entry.Title;
    switch (matchValue.tag) {
        case 0: {
            const text = matchValue.fields[0];
            const wrapper = tw(singleton_1(md(display_hidden)));
            if (entry.BodyH1.tag === 1) {
                return HtmlHelper_createElement("span", ofArray([["className", toText(printf("%s %s"))(wrapper)(MobileBar_pillClasses)], ["children", singleton_1(text)]]));
            }
            else {
                return HtmlHelper_createElement("h1", ofArray([["className", toText(printf("%s %s"))(wrapper)(MobileBar_pillClasses)], ["children", singleton_1(text)]]));
            }
        }
        default:
            return defaultOf();
    }
}

/**
 * Renders the back-arrow link to the parent route, or Html.none if no parent.
 */
export function MobileBar_mobileBackArrow(parent, dispatch) {
    if (parent != null) {
        const parentRoute = parent;
        let parentTitle;
        const matchValue = lookup(parentRoute).Title;
        parentTitle = ((matchValue.tag === 0) ? matchValue.fields[0] : "previous page");
        return HtmlHelper_createElement("a", ofArray([["href", "#"], ["aria-label", toText(printf("Back to %s"))(parentTitle)], ["className", tw(ofArray([md(display_hidden), display_inlineFlex, alignItems_itemsCenter, justifyContent_justifyCenter, width_w9, height_h9, textColor_textNeutral700, hover(textColor_textPrimary600), FocusVisible_ring, borderRadius_roundedMd]))], ["onClick", (e) => {
            e.preventDefault();
            dispatch(new ClientTypes_Msg(37, [parentRoute]));
        }], ["children", [createElement(icon_2, {
            name: new IconName(37, []),
            size: new IconSize(0, []),
            weight: new IconWeight(0, []),
        })]]]));
    }
    else {
        return defaultOf();
    }
}

/**
 * Hamburger / close button for mobile nav, hidden on desktop (md and up)
 */
export function MobileNav_menuButton(model, dispatch) {
    return HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_flex, md(display_hidden), alignItems_itemsCenter, justifyContent_justifyCenter, padding_p2, borderRadius_roundedMd, hover(backgroundColor_bgNeutral100), transition_transitionColors, textColor_textNeutral600, focusVisible(ring_ring2), focusVisible(ringColor_ringPrimary500), focusVisible(ringOffsetWidth_ringOffset2)]))], ["aria-label", model.ShowMobileMenu ? "Close menu" : "Open menu"], ["aria-expanded", model.ShowMobileMenu ? "true" : "false"], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(16, []));
    }], ["children", toList(delay(() => (model.ShowMobileMenu ? singleton(createElement(icon_2, {
        name: new IconName(36, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    })) : singleton(createElement(icon_2, {
        name: new IconName(20, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    })))))]]));
}

function MobileNav_mobileNavLink(label, icon, route, currentRoute, dispatch) {
    return HtmlHelper_createElement("a", toList(delay(() => append(singleton(["href", "#"]), delay(() => append(equals(navRoute(currentRoute), route) ? singleton(["aria-current", "page"]) : empty(), delay(() => append(singleton(["className", tw(toList(delay(() => append(singleton(display_flex), delay(() => append(singleton(alignItems_itemsCenter), delay(() => append(singleton(gap_gap$002D4), delay(() => append(singleton(padding_px4), delay(() => append(singleton(padding_py3), delay(() => append(singleton(fontSize_textBase), delay(() => append(equals(navRoute(currentRoute), route) ? append(singleton(textColor_textPrimary600), delay(() => singleton(fontWeight_fontMedium))) : append(singleton(textColor_textNeutral700), delay(() => singleton(hover(textColor_textPrimary600)))), delay(() => append(singleton(focusVisible(ring_ring2)), delay(() => append(singleton(focusVisible(ringColor_ringPrimary500)), delay(() => append(singleton(outline_outlineNone), delay(() => singleton(borderRadius_roundedMd))))))))))))))))))))))))]), delay(() => append(singleton(["onClick", (e) => {
        e.preventDefault();
        dispatch(new ClientTypes_Msg(17, []));
        dispatch(new ClientTypes_Msg(18, [route]));
    }]), delay(() => singleton(["children", [createElement(icon_2, {
        name: icon,
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    }), label]]))))))))))));
}

function MobileNav_mobileThemeOption(label, icon, pref, current, dispatch) {
    return HtmlHelper_createElement("button", ofArray([["role", join(" ", ["radio"])], ["aria-checked", equals(pref, current) ? "true" : "false"], ["tabIndex", equals(pref, current) ? 0 : -1], ["data-theme", (pref.tag === 1) ? "dark" : ((pref.tag === 2) ? "system" : "light")], ["className", tw(toList(delay(() => append(singleton(display_flex), delay(() => append(singleton(alignItems_itemsCenter), delay(() => append(singleton(gap_gap$002D4), delay(() => append(singleton(width_wFull), delay(() => append(singleton(padding_px4), delay(() => append(singleton(padding_py3), delay(() => append(singleton(fontSize_textBase), delay(() => append(singleton(textColor_textNeutral700), delay(() => append(singleton(hover(backgroundColor_bgNeutral100)), delay(() => append(equals(pref, current) ? append(singleton(backgroundColor_bgNeutral50), delay(() => singleton(fontWeight_fontMedium))) : empty(), delay(() => append(singleton(focusVisible(ring_ring2)), delay(() => append(singleton(focusVisible(ringColor_ringPrimary500)), delay(() => append(singleton(outline_outlineNone), delay(() => singleton(borderRadius_roundedMd))))))))))))))))))))))))))))))], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(13, [pref]));
    }], ["children", toList(delay(() => append(singleton(createElement(icon_2, {
        name: icon,
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    })), delay(() => append(singleton(HtmlHelper_createElement("span", singleton_1(["children", singleton_1(label)]))), delay(() => (equals(pref, current) ? singleton(HtmlHelper_createElement("span", ofArray([["className", tw(singleton_1("ml-auto"))], ["children", [createElement(icon_2, {
        name: new IconName(32, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    })]]]))) : empty())))))))]]));
}

const MobileNav_divider = HtmlHelper_createElement("hr", singleton_1(["className", tw(ofArray([margin_my2, borderColor_borderNeutral200]))]));

function MobileNav_mobileMenuPanelChildren(model, dispatch) {
    return ofArray([HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, justifyContent_justifyEnd, padding_p4]))], ["children", [HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([padding_p2, borderRadius_roundedMd, hover(backgroundColor_bgNeutral100), textColor_textNeutral600, focusVisible(ring_ring2), focusVisible(ringColor_ringPrimary500), outline_outlineNone]))], ["aria-label", "Close menu"], ["autoFocus", true], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(17, []));
    }], ["children", [createElement(icon_2, {
        name: new IconName(36, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    })]]]))]]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([padding_px4, "pb-6"]))], ["children", toList(delay(() => {
        let matchValue;
        return append((matchValue = model.Auth, (matchValue.tag === 1) ? append(singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([padding_px4, "pb-3", fontSize_textSm, textColor_textNeutral500, "truncate"]))], ["children", singleton_1(defaultArg(matchValue.fields[1], "User"))]]))), delay(() => singleton(MobileNav_divider))) : (empty())), delay(() => append(singleton(HtmlHelper_createElement("nav", ofArray([["className", tw(singleton_1("py-2"))], ["children", toList(delay(() => append(singleton(MobileNav_mobileNavLink("Support Others", new IconName(16, []), new ClientTypes_Route(1, []), model.CurrentRoute, dispatch)), delay(() => {
            if (model.Auth.tag === 1) {
                return append(singleton(MobileNav_mobileNavLink("Challenge Myself", new IconName(17, []), new ClientTypes_Route(0, []), model.CurrentRoute, dispatch)), delay(() => singleton(MobileNav_mobileNavLink("Create", new IconName(18, []), new ClientTypes_Route(3, []), model.CurrentRoute, dispatch))));
            }
            else {
                return empty();
            }
        }))))]]))), delay(() => append(singleton(MobileNav_divider), delay(() => append(singleton(HtmlHelper_createElement("div", ofArray([["role", join(" ", ["radiogroup"])], ["aria-label", "Theme"], ["className", tw(singleton_1("py-2"))], ["onKeyDown", (e) => {
            const container = e.currentTarget;
            const radios = container.querySelectorAll("[role=\'radio\']");
            if (radios.length > 0) {
                const current = document.activeElement;
                let currentIdx = -1;
                for (let i = 0; i <= (radios.length - 1); i++) {
                    if (equals(radios[i], current)) {
                        currentIdx = (i | 0);
                    }
                }
                const focusAndSelect = (idx) => {
                    e.preventDefault();
                    const el = radios[idx];
                    el.focus();
                    const matchValue_2 = el.getAttribute("data-theme");
                    switch (matchValue_2) {
                        case "light": {
                            dispatch(new ClientTypes_Msg(13, [new ClientTypes_ThemePreference(0, [])]));
                            break;
                        }
                        case "dark": {
                            dispatch(new ClientTypes_Msg(13, [new ClientTypes_ThemePreference(1, [])]));
                            break;
                        }
                        case "system": {
                            dispatch(new ClientTypes_Msg(13, [new ClientTypes_ThemePreference(2, [])]));
                            break;
                        }
                        default:
                            undefined;
                    }
                };
                const matchValue_3 = e.key;
                switch (matchValue_3) {
                    case "ArrowDown":
                    case "ArrowRight": {
                        focusAndSelect((currentIdx < 0) ? 0 : ((currentIdx + 1) % radios.length));
                        break;
                    }
                    case "ArrowUp":
                    case "ArrowLeft": {
                        focusAndSelect((currentIdx < 0) ? (radios.length - 1) : ((currentIdx === 0) ? (radios.length - 1) : (currentIdx - 1)));
                        break;
                    }
                    case "Home": {
                        focusAndSelect(0);
                        break;
                    }
                    case "End": {
                        focusAndSelect(radios.length - 1);
                        break;
                    }
                    default:
                        undefined;
                }
            }
        }], ["children", [MobileNav_mobileThemeOption("Light", new IconName(21, []), new ClientTypes_ThemePreference(0, []), model.ThemePreference, dispatch), MobileNav_mobileThemeOption("Dark", new IconName(22, []), new ClientTypes_ThemePreference(1, []), model.ThemePreference, dispatch), MobileNav_mobileThemeOption("System", new IconName(23, []), new ClientTypes_ThemePreference(2, []), model.ThemePreference, dispatch)]]]))), delay(() => append(singleton(MobileNav_divider), delay(() => singleton(HtmlHelper_createElement("div", ofArray([["className", tw(singleton_1("py-2"))], ["children", toList(delay(() => {
            const matchValue_4 = model.Auth;
            switch (matchValue_4.tag) {
                case 1:
                    return append(singleton(HtmlHelper_createElement("a", ofArray([["href", "#"], ["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D4, padding_px4, padding_py3, fontSize_textBase, textColor_textNeutral700, hover(textColor_textPrimary600), focusVisible(ring_ring2), focusVisible(ringColor_ringPrimary500), outline_outlineNone, borderRadius_roundedMd]))], ["onClick", (e_1) => {
                        e_1.preventDefault();
                        dispatch(new ClientTypes_Msg(17, []));
                        dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(5, [])]));
                    }], ["children", [createElement(icon_2, {
                        name: new IconName(27, []),
                        size: new IconSize(1, []),
                        weight: new IconWeight(0, []),
                    }), "Profile"]]]))), delay(() => singleton(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D4, width_wFull, padding_px4, padding_py3, fontSize_textBase, textColor_textNeutral700, hover(textColor_textPrimary600), focusVisible(ring_ring2), focusVisible(ringColor_ringPrimary500), outline_outlineNone, borderRadius_roundedMd]))], ["onClick", (_arg_3) => {
                        dispatch(new ClientTypes_Msg(17, []));
                        dispatch(new ClientTypes_Msg(8, []));
                    }], ["children", [createElement(icon_2, {
                        name: new IconName(28, []),
                        size: new IconSize(1, []),
                        weight: new IconWeight(0, []),
                    }), "Sign Out"]]])))));
                case 2:
                case 3:
                case 4:
                    return singleton(defaultOf());
                default:
                    return append(singleton(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D4, width_wFull, padding_px4, padding_py3, borderRadius_roundedLg, backgroundColor_bgSecondary600, textColor_white, fontWeight_fontSemibold, hover(backgroundColor_bgSecondary700), focusVisible(ring_ring2), focusVisible(ringColor_ringPrimary500), outline_outlineNone, transition_transitionColors]))], ["onClick", (_arg_1) => {
                        dispatch(new ClientTypes_Msg(17, []));
                        dispatch(new ClientTypes_Msg(1, []));
                    }], ["children", [createElement(icon_2, {
                        name: new IconName(24, []),
                        size: new IconSize(1, []),
                        weight: new IconWeight(0, []),
                    }), "Sign In"]]]))), delay(() => singleton(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D4, width_wFull, padding_px4, padding_py3, margin_mt2, borderRadius_roundedLg, border_border2, borderColor_borderSecondary600, textColor_textSecondary600, fontWeight_fontSemibold, hover(backgroundColor_bgSecondary50), focusVisible(ring_ring2), focusVisible(ringColor_ringPrimary500), outline_outlineNone, transition_transitionColors]))], ["onClick", (_arg_2) => {
                        dispatch(new ClientTypes_Msg(17, []));
                        dispatch(ClientTypes_signUpMsg(model.CurrentRoute));
                    }], ["children", [createElement(icon_2, {
                        name: new IconName(25, []),
                        size: new IconSize(1, []),
                        weight: new IconWeight(0, []),
                    }), "Sign Up"]]])))));
            }
        }))]])))))))))))));
    }))]]))]);
}

function MobileNav_MobileMenuPanel($props) {
    const dispatch = $props.dispatch;
    const model = $props.model;
    const dialogRef = useRef(undefined);
    useEffect(() => {
        const setup = (() => {
        let disp;
        const mainEl = document.querySelector("main");
        const footerEl = document.querySelector("footer");
        const headerNavEl = document.querySelector("nav[aria-label=\'Main navigation\']");
        if (!Operators_IsNull(mainEl)) {
            mainEl.setAttribute("inert", "");
        }
        if (!Operators_IsNull(footerEl)) {
            footerEl.setAttribute("inert", "");
        }
        if (!Operators_IsNull(headerNavEl)) {
            headerNavEl.setAttribute("inert", "");
        }
        let cleanup;
        const matchValue = dialogRef.current;
        if (matchValue != null) {
            const dialogEl = matchValue;
            const selector = "a[href], button:not([disabled]):not([tabindex=\"-1\"]), [tabindex]:not([tabindex=\"-1\"]), input:not([disabled])";
            const handler = (evt) => {
                const e = evt;
                if (e.key === "Tab") {
                    const focusable = dialogEl.querySelectorAll(selector);
                    if (focusable.length > 0) {
                        const first = focusable[0];
                        const last = focusable[(focusable.length - 1)];
                        const active = document.activeElement;
                        if (e.shiftKey && equals(active, first)) {
                            e.preventDefault();
                            last.focus();
                        }
                        else if (!e.shiftKey && equals(active, last)) {
                            e.preventDefault();
                            first.focus();
                        }
                    }
                }
            };
            dialogEl.addEventListener("keydown", handler);
            cleanup = (() => {
                dialogEl.removeEventListener("keydown", handler);
            });
        }
        else {
            cleanup = (() => {
            });
        }
        disp = {
            Dispose() {
                cleanup();
                if (!Operators_IsNull(mainEl)) {
                    mainEl.removeAttribute("inert");
                }
                if (!Operators_IsNull(footerEl)) {
                    footerEl.removeAttribute("inert");
                }
                if (!Operators_IsNull(headerNavEl)) {
                    headerNavEl.removeAttribute("inert");
                }
            },
        };
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, []);;
    return HtmlHelper_createElement("div", ofArray([["ref", (el) => {
        dialogRef.current = (Operators_IsNull(el) ? undefined : el);
    }], ["role", join(" ", ["dialog"])], ["aria-modal", true], ["aria-label", "Main navigation"], ["className", tw(ofArray([position_fixed$0027, "right-0", "top-0", "bottom-0", width_w72, backgroundColor_bgSurfaceElevated, boxShadow_shadowXl, "z-40", display_flex, flexDirection_flexCol, "overflow-y-auto", "transition-transform", "duration-200", "ease-out", "motion-reduce:transition-none", md(display_hidden)]))], ["onKeyDown", (e_1) => {
        if (e_1.key === "Escape") {
            e_1.preventDefault();
            dispatch(new ClientTypes_Msg(17, []));
        }
    }], ["children", MobileNav_mobileMenuPanelChildren(model, dispatch)]]));
}

/**
 * Slideout panel with overlay, nav links, theme options, and auth actions
 */
export function MobileNav_menuPanel(model, dispatch) {
    if (!model.ShowMobileMenu) {
        return defaultOf();
    }
    else {
        const xs_1 = [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([position_fixed$0027, position_inset0, backgroundColor_bgBlack, opacity_opacity20, zIndex_z30, md(display_hidden)]))], ["aria-hidden", true], ["onClick", (_arg) => {
            dispatch(new ClientTypes_Msg(17, []));
        }]])), createElement(MobileNav_MobileMenuPanel, {
            model: model,
            dispatch: dispatch,
        })];
        return createElement(Fragment, defaultOf_1(), ...xs_1);
    }
}

const Dashboard_challengeListHeading = HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900, margin_mb4]))], ["children", [createElement(icon_2, {
    name: new IconName(51, []),
    size: new IconSize(1, []),
    weight: new IconWeight(0, []),
}), "Your Challenges"]]]));

function Dashboard_challengeListCards(model, dispatch) {
    return render(model.Challenges, () => {
        dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(3, [])]));
    }, () => {
        dispatch(new ClientTypes_Msg(43, []));
    }, (id) => {
        dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(2, [id])]));
    }, (action) => {
        switch (action.tag) {
            case 1: {
                dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(2, [action.fields[0]])]));
                break;
            }
            case 2: {
                dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(2, [action.fields[0]])]));
                break;
            }
            case 3: {
                break;
            }
            default:
                dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(2, [action.fields[0]])]));
        }
    });
}

function Dashboard_compactHostCta(dispatch) {
    return HtmlHelper_createElement("div", ofArray([["data-testid", "dashboard-compact-cta"], ["children", [emptyStateCompact(new IconName(17, []), "Ready to start your own challenge?"), HtmlHelper_createElement("div", ofArray([["className", tw(singleton_1(textAlign_center))], ["children", [HtmlHelper_createElement("button", ofArray([["className", TailwindHelpers_buttonPrimary], ["children", singleton_1("Create Challenge")], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(3, [])]));
    }]]))]]]))]]]));
}

function Dashboard_inactiveHostCta(dispatch) {
    return HtmlHelper_createElement("div", singleton_1(["children", [emptyStateCompact(new IconName(17, []), "No active challenges."), HtmlHelper_createElement("div", ofArray([["className", tw(singleton_1(textAlign_center))], ["children", [HtmlHelper_createElement("button", ofArray([["className", TailwindHelpers_buttonPrimary], ["children", singleton_1("Start Another Challenge")], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(3, [])]));
    }]]))]]]))]]));
}

function Dashboard_newUserEmptyState(dispatch) {
    return emptyStateFull(new IconName(17, []), "No challenges yet", "Create a personal challenge to raise money for a cause you care about.", "Create Your First Challenge", () => {
        dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(3, [])]));
    });
}

function Dashboard_hasCompletedChallenges(model) {
    const matchValue = model.CompletedChallenges;
    let matchResult;
    if (matchValue.tag === 2) {
        if (!isEmpty(matchValue.fields[0])) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return true;
        default:
            return false;
    }
}

function Dashboard_hasPledges(model) {
    const matchValue = model.MyPledges;
    let matchResult;
    if (matchValue != null) {
        if (!isEmpty(matchValue)) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return true;
        default:
            return false;
    }
}

export function Dashboard_challengeListSection(challengeDetailContent, model, dispatch) {
    return HtmlHelper_createElement("div", ofArray([["data-testid", "dashboard-host-section"], ["className", tw(ofArray([backgroundColor_bgSurface, borderRadius_roundedLg, boxShadow_shadow, padding_p6]))], ["children", toList(delay(() => {
        const matchValue = model.Challenges;
        let matchResult, single;
        switch (matchValue.tag) {
            case 2: {
                if (!isEmpty(matchValue.fields[0])) {
                    if (isEmpty(tail(matchValue.fields[0]))) {
                        matchResult = 0;
                        single = head(matchValue.fields[0]);
                    }
                    else {
                        matchResult = 5;
                    }
                }
                else {
                    matchResult = 5;
                }
                break;
            }
            case 1: {
                if (Dashboard_hasCompletedChallenges(model)) {
                    matchResult = 1;
                }
                else if (!model.LoadingMyPledges && Dashboard_hasPledges(model)) {
                    matchResult = 2;
                }
                else if (model.LoadingMyPledges) {
                    matchResult = 3;
                }
                else {
                    matchResult = 4;
                }
                break;
            }
            default:
                matchResult = 5;
        }
        switch (matchResult) {
            case 0:
                if (model.LoadingChallenge) {
                    return singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([textAlign_center, padding_py8]))], ["children", [HtmlHelper_createElement("p", ofArray([["className", textColor_textNeutral600], ["children", singleton_1("Loading challenge...")]]))]]])));
                }
                else {
                    const matchValue_1 = model.CurrentChallenge;
                    let matchResult_1, ch_1;
                    if (matchValue_1 != null) {
                        if (matchValue_1.Id === single.Id) {
                            matchResult_1 = 0;
                            ch_1 = matchValue_1;
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                    switch (matchResult_1) {
                        case 0:
                            return singleton(challengeDetailContent(model, dispatch));
                        default:
                            return append(singleton(Dashboard_challengeListHeading), delay(() => singleton(Dashboard_challengeListCards(model, dispatch))));
                    }
                }
            case 1:
                return append(singleton(Dashboard_challengeListHeading), delay(() => singleton(Dashboard_inactiveHostCta(dispatch))));
            case 2:
                return singleton(Dashboard_compactHostCta(dispatch));
            case 3: {
                return empty();
            }
            case 4:
                return singleton(Dashboard_newUserEmptyState(dispatch));
            default:
                return append(singleton(Dashboard_challengeListHeading), delay(() => singleton(Dashboard_challengeListCards(model, dispatch))));
        }
    }))]]));
}

export function Dashboard_pastChallengesSection(model, dispatch) {
    const matchValue = model.CompletedChallenges;
    let matchResult, challenges;
    if (matchValue.tag === 2) {
        if (!isEmpty(matchValue.fields[0])) {
            matchResult = 0;
            challenges = matchValue.fields[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return HtmlHelper_createElement("div", ofArray([["data-testid", "dashboard-past-section"], ["className", tw(ofArray([backgroundColor_bgSurface, borderRadius_roundedLg, boxShadow_shadow, padding_p6]))], ["children", [HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900, margin_mb4]))], ["children", [createElement(icon_2, {
                name: new IconName(47, []),
                size: new IconSize(1, []),
                weight: new IconWeight(0, []),
            }), "Past Challenges"]]])), render(new ListState(2, [challenges]), () => {
            }, () => {
            }, (id) => {
                dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(2, [id])]));
            }, (value_10) => {
            })]]]));
        default:
            return defaultOf();
    }
}

export function Dashboard_quickActions(dispatch) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([backgroundColor_bgSurface, borderRadius_roundedLg, boxShadow_shadow, padding_p6]))], ["children", [HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900, margin_mb4]))], ["children", singleton_1("Quick Actions")]])), HtmlHelper_createElement("div", ofArray([["className", space_spaceY3], ["children", [HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([width_wFull, padding_px4, padding_py3, backgroundColor_bgPrimary600, textColor_textOnPrimary, borderRadius_roundedMd, hover(backgroundColor_bgPrimary700), display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, gap_gap$002D2, FocusVisible_ring, transition_transitionColors]))], ["children", [createElement(icon_2, {
        name: new IconName(18, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    }), HtmlHelper_createElement("span", singleton_1(["children", singleton_1("Create Challenge")]))]], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(3, [])]));
    }]])), HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([width_wFull, padding_px4, padding_py3, border_border, borderColor_borderNeutral300, textColor_textNeutral700, borderRadius_roundedMd, hover(backgroundColor_bgNeutral50), display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, gap_gap$002D2, FocusVisible_ring, transition_transitionColors]))], ["children", [createElement(icon_2, {
        name: new IconName(46, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    }), HtmlHelper_createElement("span", singleton_1(["children", singleton_1("Browse Challenges")]))]], ["onClick", (_arg_1) => {
        dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(1, [])]));
    }]]))]]]))]]]));
}

export function Dashboard_dashboardView(challengeDetailContent, model, dispatch) {
    let matchValue, email, arg;
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flex_flexCol, gap_gap$002D6, lg(display_grid), lg(grid_gridCols1fr280px), lg(gap_gap8)]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(singleton_1(space_spaceY6))], ["children", [HomePromo_view(Clock_system.UtcNow(), dispatch), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([backgroundImage_bgGradientToR, gradientColorStops_fromPrimary500, gradientColorStops_toSecondary600, borderRadius_roundedLg, padding_p6, textColor_white]))], ["children", [HtmlHelper_createElement("h2", ofArray([["className", tw(ofArray([fontSize_text2Xl, fontWeight_fontBold, margin_mb2]))], ["children", singleton_1((matchValue = model.Auth, (matchValue.tag === 1) ? ((matchValue.fields[1] != null) ? ((email = matchValue.fields[1], (arg = item(0, split(email, ["@"], undefined, 0)), toText(printf("Welcome back, %s!"))(arg)))) : "Welcome to You-thon!") : "Welcome to You-thon!"))]])), HtmlHelper_createElement("p", ofArray([["className", textColor_textPrimary50], ["children", singleton_1("Ready to make a difference? Start a challenge and raise money for your favorite charity.")]]))]]])), Dashboard_challengeListSection(challengeDetailContent, model, dispatch), view_1(model, dispatch), Dashboard_pastChallengesSection(model, dispatch)]]])), HtmlHelper_createElement("div", ofArray([["className", tw(singleton_1(space_spaceY6))], ["children", [Dashboard_quickActions(dispatch), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([backgroundColor_bgSurface, borderRadius_roundedLg, boxShadow_shadow, padding_p6]))], ["children", [HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900, margin_mb4]))], ["children", singleton_1("Your Impact")]])), HtmlHelper_createElement("div", ofArray([["className", space_spaceY3], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D3]))], ["children", [createElement(icon_2, {
        name: new IconName(42, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    }), HtmlHelper_createElement("div", singleton_1(["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral600]))], ["children", singleton_1("Total Raised")]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_text2Xl, fontWeight_fontBold, textColor_textPrimary600]))], ["children", singleton_1("$0.00")]]))]]))]]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D3]))], ["children", [createElement(icon_2, {
        name: new IconName(6, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    }), HtmlHelper_createElement("div", singleton_1(["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral600]))], ["children", singleton_1("Challenges Completed")]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_text2Xl, fontWeight_fontBold, textColor_textPrimary600]))], ["children", singleton_1("0")]]))]]))]]]))]]]))]]]))]]]))]]]));
}

function LandingPage_featureCard(iconName, heading, description) {
    return HtmlHelper_createElement("div", ofArray([["className", textAlign_center], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([width_w12, height_h12, borderRadius_roundedFull, backgroundColor_bgPrimary100, display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, margin_mxAuto]))], ["children", [createElement(icon_2, {
        name: iconName,
        size: new IconSize(2, []),
        weight: new IconWeight(0, []),
    })]]])), HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([fontSize_textXl, fontWeight_fontSemibold, margin_mt4]))], ["children", singleton_1(heading)]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([textColor_textNeutral600, margin_mt2]))], ["children", singleton_1(description)]]))]]]));
}

function LandingPage_ctaButtons(model, dispatch) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flex_flexCol, sm(flex_flexRow), gap_gap4, alignItems_itemsCenter, justifyContent_justifyCenter]))], ["children", [HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, gap_gap$002D2, padding_px6, padding_py3, borderRadius_roundedLg, backgroundColor_bgPrimary600, textColor_textOnPrimary, fontWeight_fontSemibold, hover(backgroundColor_bgPrimary700), FocusVisible_ring, transition_transitionColors]))], ["children", [createElement(icon_2, {
        name: new IconName(52, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    }), "Start a Challenge"]], ["onClick", (_arg) => {
        if (model.Auth.tag === 1) {
            dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(3, [])]));
        }
        else {
            dispatch(new ClientTypes_Msg(4, []));
        }
    }]])), HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([padding_px6, padding_py3, borderRadius_roundedLg, border_border2, borderColor_borderPrimary600, textColor_textPrimary600, fontWeight_fontSemibold, hover(backgroundColor_bgPrimary50), FocusVisible_ring, transition_transitionColors]))], ["children", singleton_1("Browse Challenges")], ["onClick", (_arg_1) => {
        dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(1, [])]));
    }]]))]]]));
}

const LandingPage_featureData = ofArray([[new IconName(52, []), "Create Your Challenge", "Set a personal goal and duration for your challenge"], [new IconName(3, []), "Get Sponsored", "Friends and family pledge donations based on your progress"], [new IconName(53, []), "Make a Difference", "Complete your challenge and donations go to your chosen charity"]]);

/**
 * Landing page view with mobile scroll-snap sections and responsive two-block layout.
 * On mobile (<640px): 6 full-viewport snap sections (hero with CTAs, 3 features, About, Get started CTAs).
 * At sm (>=640px): hero shows inline CTAs; at md (>=768px): features switch to a 3-column grid.
 * While the flood-relief promotion runs at `now`, the promo band shows inside the hero.
 */
export function LandingPage_viewAt(now, model, dispatch) {
    const promoRunning = PromotionModule_isRunning(now, PromotionModule_floodRelief2026);
    const logoHeight = promoRunning ? "h-12 sm:h-16" : "h-16";
    return HtmlHelper_createElement("div", singleton_1(["children", toList(delay(() => append(singleton(HtmlHelper_createElement("section", ofArray([["aria-label", "Introduction"], ["className", tw(toList(delay(() => append(singleton("snap-start"), delay(() => append(singleton(minHeight_minHDvh), delay(() => append(singleton("sm:min-h-0"), delay(() => append(singleton("sm:[scroll-snap-align:none]"), delay(() => append(singleton(display_flex), delay(() => append(singleton(flex_flexCol), delay(() => append(singleton(alignItems_itemsCenter), delay(() => append(singleton(justifyContent_justifyCenter), delay(() => append(singleton(textAlign_center), delay(() => (promoRunning ? append(singleton(padding_py4), delay(() => singleton(sm(padding_py16)))) : singleton(padding_py16)))))))))))))))))))))))], ["children", [HtmlHelper_createElement("h1", ofArray([["className", tw(singleton_1(margin_mb4))], ["children", [HtmlHelper_createElement("img", ofArray([["src", "/assets/YouThon.svg"], ["alt", "You-thon"], ["className", tw(ofArray([logoHeight, margin_mxAuto, "logo-light"]))]])), HtmlHelper_createElement("img", ofArray([["src", "/assets/YouThon-dark.svg"], ["alt", "You-thon"], ["className", tw(ofArray([logoHeight, margin_mxAuto, "logo-dark"]))]]))]]])), HtmlHelper_createElement("p", ofArray([["className", tw(toList(delay(() => append(singleton(textColor_textNeutral700), delay(() => (promoRunning ? append(singleton(fontSize_textBase), delay(() => append(singleton(sm(fontSize_textXl)), delay(() => append(singleton("mb-3"), delay(() => singleton(sm("mb-8")))))))) : append(singleton(fontSize_textXl), delay(() => singleton(margin_mb8)))))))))], ["children", singleton_1("Motivation for good.")]])), LandingPage_ctaButtons(model, dispatch), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([width_wFull, maxWidth_w3Xl, margin_mxAuto, margin_mt4, sm("mt-12"), "empty:hidden"]))], ["children", [HomePromo_view(now, dispatch)]]]))]]]))), delay(() => append(collect((matchValue) => {
        const heading = matchValue[1];
        return singleton(HtmlHelper_createElement("section", withKey(heading, ofArray([["aria-label", heading], ["className", tw(ofArray(["snap-start", minHeight_minHDvh, sm("hidden"), display_flex, flex_flexCol, alignItems_itemsCenter, justifyContent_justifyCenter, padding_py16]))], ["children", [LandingPage_featureCard(matchValue[0], heading, matchValue[2])]]]))));
    }, LandingPage_featureData), delay(() => append(singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray(["hidden", sm(display_grid), md(grid_cols$002D3), gap_gap8, padding_py16]))], ["children", toList(delay(() => collect((matchValue_1) => {
        const heading_1 = matchValue_1[1];
        return singleton(HtmlHelper_createElement("div", withKey(heading_1, singleton_1(["children", [LandingPage_featureCard(matchValue_1[0], heading_1, matchValue_1[2])]]))));
    }, LandingPage_featureData)))]]))), delay(() => append(singleton(HtmlHelper_createElement("section", ofArray([["aria-label", "About You-thon"], ["className", tw(ofArray(["snap-start", "sm:[scroll-snap-align:none]", maxWidth_w3Xl, margin_mxAuto, padding_py16]))], ["children", toList(delay(() => append(singleton(HtmlHelper_createElement("h2", ofArray([["className", tw(ofArray([fontSize_text2Xl, fontWeight_fontSemibold, textColor_textNeutral900, margin_mb4]))], ["children", singleton_1("About You-thon")]]))), delay(() => map((paragraph) => HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textBase, textColor_textNeutral700, margin_mb4]))], ["children", singleton_1(paragraph)]])), paragraphs)))))]]))), delay(() => singleton(HtmlHelper_createElement("section", ofArray([["aria-label", "Get started"], ["className", tw(ofArray(["snap-start", minHeight_minHDvh, sm("hidden"), display_flex, flex_flexCol, alignItems_itemsCenter, justifyContent_justifyCenter, padding_py16]))], ["children", [LandingPage_ctaButtons(model, dispatch)]]])))))))))))))]));
}

/**
 * Landing page view at the current wall-clock time. See `viewAt`.
 */
export function LandingPage_view(model, dispatch) {
    return LandingPage_viewAt(Clock_system.UtcNow(), model, dispatch);
}

export function navigationHeader(model, dispatch) {
    const xs_15 = [HtmlHelper_createElement("nav", ofArray([["aria-label", "Main navigation"], ["className", tw(ofArray(["sticky", "top-0", "z-20", md("relative"), md("z-auto"), backgroundColor_bgSurface, boxShadow_shadowXs]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([maxWidth_w7Xl, margin_mxAuto, padding_px4, sm(padding_px6), lg(padding_px8)]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, justifyContent_justifyBetween, alignItems_itemsCenter, "h-14", md("h-16")]))], ["children", toList(delay(() => append(singleton(HtmlHelper_createElement("a", ofArray([["href", "#"], ["aria-label", "You-thon home"], ["className", tw(ofArray([display_flex, alignItems_itemsCenter, FocusVisible_ring, borderRadius_roundedMd]))], ["onClick", (e) => {
        e.preventDefault();
        dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(0, [])]));
    }], ["children", [HtmlHelper_createElement("img", ofArray([["src", "/assets/YouThon.svg"], ["alt", "You-thon"], ["className", tw(ofArray([height_h8, "logo-light"]))]])), HtmlHelper_createElement("img", ofArray([["src", "/assets/YouThon-dark.svg"], ["alt", "You-thon"], ["className", tw(ofArray([height_h8, "logo-dark"]))]]))]]]))), delay(() => {
        const pageMeta = lookupForAuth(model.Auth, model.CurrentRoute);
        return append(singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D2, md(display_hidden)]))], ["children", [MobileBar_mobileBackArrow(pageMeta.Parent, dispatch), MobileBar_mobileTitlePill(pageMeta)]]]))), delay(() => singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D6]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_hidden, md(display_flex), alignItems_itemsCenter, gap_gap$002D4]))], ["children", toList(delay(() => append(singleton(HtmlHelper_createElement("a", toList(delay(() => append(singleton(["href", "#"]), delay(() => append(equals(model.CurrentRoute, new ClientTypes_Route(1, [])) ? singleton(["aria-current", "page"]) : empty(), delay(() => append(singleton(["className", tw(toList(delay(() => append(singleton(display_flex), delay(() => append(singleton(alignItems_itemsCenter), delay(() => append(singleton(gap_gap$002D2), delay(() => append(equals(model.CurrentRoute, new ClientTypes_Route(1, [])) ? append(singleton(textColor_textPrimary600), delay(() => singleton(fontWeight_fontMedium))) : append(singleton(textColor_textNeutral700), delay(() => singleton(hover(textColor_textPrimary600)))), delay(() => append(singleton(FocusVisible_ring), delay(() => singleton(borderRadius_roundedMd))))))))))))))]), delay(() => append(singleton(["onClick", (e_1) => {
            e_1.preventDefault();
            dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(1, [])]));
        }]), delay(() => singleton(["children", [createElement(icon_2, {
            name: new IconName(16, []),
            size: new IconSize(1, []),
            weight: new IconWeight(0, []),
        }), "Support Others"]]))))))))))))), delay(() => {
            let xs_7;
            return (model.Auth.tag === 1) ? singleton((xs_7 = [HtmlHelper_createElement("a", toList(delay(() => append(singleton(["href", "#"]), delay(() => append(equals(model.CurrentRoute, new ClientTypes_Route(0, [])) ? singleton(["aria-current", "page"]) : empty(), delay(() => append(singleton(["className", tw(toList(delay(() => append(singleton(display_flex), delay(() => append(singleton(alignItems_itemsCenter), delay(() => append(singleton(gap_gap$002D2), delay(() => append(equals(model.CurrentRoute, new ClientTypes_Route(0, [])) ? append(singleton(textColor_textPrimary600), delay(() => singleton(fontWeight_fontMedium))) : append(singleton(textColor_textNeutral700), delay(() => singleton(hover(textColor_textPrimary600)))), delay(() => append(singleton(FocusVisible_ring), delay(() => singleton(borderRadius_roundedMd))))))))))))))]), delay(() => append(singleton(["onClick", (e_2) => {
                e_2.preventDefault();
                dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(0, [])]));
            }]), delay(() => singleton(["children", [createElement(icon_2, {
                name: new IconName(17, []),
                size: new IconSize(1, []),
                weight: new IconWeight(0, []),
            }), "Challenge Myself"]])))))))))))), HtmlHelper_createElement("a", toList(delay(() => append(singleton(["href", "#"]), delay(() => append(equals(navRoute(model.CurrentRoute), new ClientTypes_Route(3, [])) ? singleton(["aria-current", "page"]) : empty(), delay(() => append(singleton(["className", tw(toList(delay(() => append(singleton(display_flex), delay(() => append(singleton(alignItems_itemsCenter), delay(() => append(singleton(gap_gap$002D2), delay(() => append(equals(navRoute(model.CurrentRoute), new ClientTypes_Route(3, [])) ? append(singleton(textColor_textPrimary600), delay(() => singleton(fontWeight_fontMedium))) : append(singleton(textColor_textNeutral700), delay(() => singleton(hover(textColor_textPrimary600)))), delay(() => append(singleton(FocusVisible_ring), delay(() => singleton(borderRadius_roundedMd))))))))))))))]), delay(() => append(singleton(["onClick", (e_3) => {
                e_3.preventDefault();
                dispatch(new ClientTypes_Msg(18, [new ClientTypes_Route(3, [])]));
            }]), delay(() => singleton(["children", [createElement(icon_2, {
                name: new IconName(18, []),
                size: new IconSize(1, []),
                weight: new IconWeight(0, []),
            }), "Create"]]))))))))))))], createElement(Fragment, defaultOf_1(), ...xs_7))) : singleton(defaultOf());
        }))))]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_hidden, md(display_block)]))], ["children", [ThemeToggle_themeToggle(model, dispatch)]]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_hidden, md(display_flex)]))], ["children", [AuthComponents_authStatus(model, dispatch, model.ShowUserMenu)]]])), MobileNav_menuButton(model, dispatch)]]])))));
    }))))]]))]]]))]]])), MobileNav_menuPanel(model, dispatch)];
    return createElement(Fragment, defaultOf_1(), ...xs_15);
}

function detailContentPlaceholder(_m, _d) {
    return HtmlHelper_createElement("p", ofArray([["className", textColor_textNeutral600], ["children", singleton_1("Loading challenge...")]]));
}

export function mainContent(model, dispatch) {
    return HtmlHelper_createElement("main", ofArray([["id", "main-content"], ["className", tw(ofArray([maxWidth_w7Xl, margin_mxAuto, padding_px4, sm(padding_px6), lg(padding_px8), padding_py8]))], ["children", toList(delay(() => {
        const matchValue = model.Auth;
        switch (matchValue.tag) {
            case 0:
                return singleton(LandingPage_view(model, dispatch));
            case 1:
                return singleton(Dashboard_dashboardView(detailContentPlaceholder, model, dispatch));
            default:
                return singleton(centeredSpinner);
        }
    }))]]));
}

export function view(model, dispatch) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([minHeight_minHScreen, backgroundColor_bgNeutral50]))], ["children", [navigationHeader(model, dispatch), mainContent(model, dispatch)]]]));
}

//# sourceMappingURL=View.js.map
